// Texts of the ERP area "Comercial" (catálogo, propostas, faturas).
export default {
  catalog: {
    // What goes ready into the proposals (19/10/2026).
    proposal: {
      title: 'Na proposta',
      hint: 'Vai pronto para toda proposta com este produto (dá para ajustar em cada proposta).',
      included: 'O que está incluso',
      notIncluded: 'O que não está incluso',
      deadline: 'Prazo',
      deadlinePlaceholder: 'Ex.: 30 dias corridos após a aprovação',
    },
    title: 'Catálogo',
    subtitle: 'Produtos e serviços usados como modelo nas propostas.',
    tabs: { items: 'Itens', lines: 'Linhas de produto' },
    newItem: 'Novo item',
    newLine: 'Nova linha',
    searchPlaceholder: 'Nome do item',
    filterActive: 'Situação',
    filterType: 'Tipo',
    filterLine: 'Linha de produto',
    active: 'Ativo',
    inactive: 'Inativo',
    emptyTitle: 'Nenhum item no catálogo',
    emptyText: 'Cadastre produtos e serviços para usar nas propostas.',
    columns: { type: 'Tipo', line: 'Linha', name: 'Nome', description: 'Descrição', price: 'Valor padrão', unit: 'Unidade', status: 'Situação' },
    types: { product: 'Produto', service: 'Serviço' },
    dialogNew: 'Novo item',
    dialogEdit: 'Editar item',
    name: 'Nome',
    description: 'Descrição',
    defaultPrice: 'Valor padrão',
    defaultPriceMonthly: 'Valor mensal',
    unit: 'Unidade',
    fields: { billing: 'Cobrança' },
    billing: { one_time: 'Valor único', monthly: 'Mensalidade' },
    billingHint: 'Cobrado todo mês, sem prazo final. Na proposta aparece como mensalidade.',
    perMonth: '/mês',
    unitPlaceholder: 'Ex.: mês, hora, projeto',
    type: 'Tipo',
    line: 'Linha de produto',
    noLine: 'Sem linha',
    projectTemplate: 'Modelo de projeto',
    projectTemplateHint: 'Ao aprovar uma proposta com este produto, o projeto é criado com este modelo (se a proposta não escolher outro).',
    noProjectTemplate: 'Nenhum (vale o modelo padrão)',
    activeLabel: 'Item ativo (aparece nas propostas)',
    lines: {
      empty: 'Nenhuma linha de produto cadastrada.',
      columns: { name: 'Nome', key: 'Chave', order: 'Ordem', items: 'Itens', status: 'Situação' },
      dialogNew: 'Nova linha de produto',
      dialogEdit: 'Editar linha de produto',
      name: 'Nome',
      key: 'Chave',
      keyHint: 'Gerada a partir do nome; não muda depois.',
      order: 'Ordem',
      activeLabel: 'Linha ativa',
    },
  },
  proposals: {
    title: 'Propostas',
    subtitle: 'Propostas comerciais com versões e PDF.',
    new: 'Nova proposta',
    searchPlaceholder: 'Cliente, item ou número',
    noCustomer: 'Sem cliente',
    filterCustomer: 'Cliente',
    filterStatus: 'Status',
    filterConsultant: 'Consultor',
    emptyTitle: 'Nenhuma proposta',
    emptyText: 'Crie a primeira proposta comercial.',
    columns: { createdAt: 'Criada em', proposal: 'Proposta', number: 'Nº', customer: 'Cliente', project: 'Projeto', amount: 'Valor', validUntil: 'Validade', status: 'Status' },
    status: {
      draft: 'Rascunho',
      sent: 'Enviada',
      approved: 'Aprovada',
      rejected: 'Recusada',
      expired: 'Expirada',
      cancelled: 'Cancelada',
    },
    events: {
      created: 'Proposta criada',
      edited: 'Proposta editada',
      pdf_generated: 'PDF gerado',
      sent: 'Marcada como enviada',
      approved: 'Aprovada',
      rejected: 'Recusada',
      expired: 'Expirada',
      revised: 'Nova versão criada',
      cancelled: 'Cancelada',
      note: 'Nota',
      email_sent: 'Enviada por e-mail',
    },
    // "Enviar por e-mail" (23/10/2026).
    email: {
      open: 'Enviar por e-mail',
      title: 'Enviar a proposta por e-mail',
      to: 'Para',
      toHint: 'E-mails separados por vírgula. Vem o contato da proposta (A/C) ou as pessoas de contato do cliente.',
      cc: 'Cópia (Cc)',
      ccHint: 'O padrão fica em Configurações › Módulo ERP › Documentos.',
      subject: 'Assunto',
      body: 'Mensagem',
      signature: 'Sua assinatura vai no fim. As respostas chegam no seu e-mail.',
      send: 'Enviar com o PDF',
      marksAsSent: 'Ao enviar, a proposta passa para "Enviada" e a validade começa a contar hoje.',
      viaGmail: 'Vai pelo seu Gmail e fica nos seus Enviados.',
      lastSent: 'Já enviada por e-mail em {date} para {to} (por {name}).',
      sentGmail: 'Proposta enviada para {to} pelo seu Gmail, com o PDF.',
      sent: 'Proposta enviada para {to}, com o PDF.',
    },
    detail: {
      linkProject: {
        open: 'Vincular projeto',
        label: 'Projeto do cliente',
        choose: 'Escolha o projeto',
        confirm: 'Vincular',
        none: 'O cliente da proposta ainda não tem projetos.',
        noCustomer: 'Escolha o cliente da proposta para vincular um projeto.',
        done: 'Projeto vinculado à proposta.',
        hint: 'Depois de vinculado, o projeto não muda mais.',
      },
      newTitle: 'Nova proposta',
      heading: 'Proposta {number}',
      version: 'v{version}',
      editing: 'Editando',
      back: 'Voltar às propostas',
      notFound: 'Proposta não encontrada.',
      save: 'Salvar',
      cancelEdit: 'Cancelar edição',
      edit: 'Editar',
      pdf: 'Gerar PDF',
      send: 'Marcar como enviada',
      downloadSent: 'Baixar PDF enviado',
      approve: 'Aprovar',
      reject: 'Recusar',
      revise: 'Revisar (nova versão)',
      cancel: 'Cancelar proposta',
      delete: 'Excluir',
      banner: {
        draft: 'Rascunho: edite à vontade. Ao marcar como enviada, a validade começa a contar e a proposta fica travada.',
        sent: 'Enviada em {sentOn}, válida até {validUntil}.',
        approved: 'Aprovada em {date}.',
        rejected: 'Recusada: {reason}',
        expired: 'A validade venceu em {validUntil} sem resposta do cliente. Revise para enviar uma nova versão.',
        cancelled: 'Cancelada: {reason}',
      },
      missing: 'Preencha antes de continuar: {list}.',
      previewPdf: 'Ver PDF',
      saveAndPreview: 'Salvar e ver o PDF',
      deadlinesEmpty: 'Nenhum produto com prazo. Preencha o prazo no produto (ou no Catálogo).',
      validUntil: 'Válida até {date}',
      checklist: {
        title: 'Seções da proposta',
        customer: 'Cliente',
        products: 'Produtos',
        included: 'O que está incluso',
        notIncluded: 'O que não está incluso',
        investment: 'Investimento',
        deadlines: 'Prazos',
        validity: 'Validade',
      },
      // The same sections as the PDF (19/10/2026).
      sections: {
        data: 'Cliente',
        products: 'Produtos',
        deadlines: 'Prazos',
        validity: 'Validade',
        payment: 'Investimento',
        history: 'Histórico',
        versions: 'Versões enviadas',
      },
      fields: {
        customer: 'Cliente',
        contact: 'A/C (contato)',
        noContact: 'Sem contato',
        project: 'Projeto',
        // 23/10/2026: what the approval created in Financeiro (the entries carry the proposal's number).
        finance: 'Financeiro',
        financeLink: 'Ver as contas a receber',
        validityDays: 'Validade (dias)',
        legacyOutOfScope: 'Não incluso nesta proposta (texto antigo)',
        legacyOutOfScopeHint: 'Das propostas de antes: hoje o "não incluso" fica em cada produto. Apague para tirar do PDF.',
        deadlinesNote: 'Observação de prazo (opcional)',
        deadlinesNotePlaceholder: 'Ex.: o início acontece após a assinatura do contrato.',
        topicsHint: 'Um tópico por linha; comece com - para subtópico.',
        valuesNote: 'Observação abaixo dos valores (opcional)',
        condition: 'Forma de pagamento',
        downPaymentPercent: 'Entrada (%)',
        downPaymentDueDate: 'Vencimento da entrada',
        installments: 'Parcelas',
        installmentsAfter: 'Parcelas após a entrada',
        firstDueDate: 'Vencimento da 1ª parcela',
        cashDueDate: 'Vencimento do pagamento',
        monthlyFirstDueDate: 'Vencimento da 1ª mensalidade',
        monthly: 'Mensalidade',
        from: 'a partir de {date}',
        dateFallback: 'Sem data, o vencimento será o dia da aprovação.',
        notes: 'Observações internas',
      },
      conditions: {
        cash: 'À vista',
        installments: 'Parcelado sem entrada',
        down_payment_and_installments: 'Entrada + parcelas',
      },
      items: {
        title: 'Título do item',
        amount: 'Valor',
        amountMonthly: 'Valor mensal',
        description: 'Descrição',
        up: 'Subir',
        down: 'Descer',
        remove: 'Remover item',
        fromCatalog: 'Adicionar do catálogo…',
        fromCatalogHint: 'Veio do Catálogo. O que você mudar aqui vale só para esta proposta.',
        free: '+ Item livre',
        total: 'Total',
        totalProject: 'Total do projeto',
        totalMonthly: 'Mensalidade',
        empty: 'Nenhum item ainda.',
        catalogTitle: 'Adicionar do catálogo',
        catalogEmpty: 'Nenhum item ativo no catálogo.',
        add: 'Adicionar',
      },
      paymentPreview: 'No PDF: Forma de pagamento: {text}',
      oneTimeTitle: 'Projeto fechado · {value}',
      monthlyTitle: 'Mensalidade · {value} por mês, sem prazo final',
      paymentPreviewEmpty: 'Adicione itens com valor para ver a forma de pagamento.',
      // 22/10/2026: the proposal has no due dates.
      datesLater: 'Os vencimentos não vão na proposta: são combinados no fechamento do contrato e ajustados no Financeiro depois da aprovação.',
      legacyPayment: 'Texto antigo de pagamento: {text}',
      history: {
        empty: 'Nenhum evento.',
        note: 'Anotar',
        notePlaceholder: 'Escreva uma nota para o histórico',
        by: 'por {name}',
      },
      versions: { empty: 'Nenhuma versão enviada ainda.', label: 'Versão {version} · {date}', download: 'Baixar PDF' },
      confirm: {
        discardTitle: 'Descartar alterações?',
        discardText: 'As alterações não salvas serão perdidas.',
        discard: 'Descartar',
        sendTitle: 'Marcar como enviada?',
        sendText: 'A validade de {days} dias começa a contar hoje e a proposta não poderá mais ser editada (só revisada).',
        approveTitle: 'Aprovar a proposta?',
        approveIntro: 'Ao aprovar, o sistema cria automaticamente:',
        approveEntries: 'as contas a receber no Financeiro (entrada e parcelas) e, se houver, a mensalidade todo mês. Os vencimentos são sugeridos (entrada em 7 dias, parcela 30 dias depois, mensalidade no dia 10 do mês seguinte) e ajustados no Financeiro quando o contrato for fechado;',
        approveProject: 'e o projeto vinculado passa para "Em andamento".',
        approveNewProject: 'e o projeto do cliente, já "Em andamento", com as tarefas do modelo de projeto (o escolhido na proposta, o padrão ou o único cadastrado).',
        rejectTitle: 'Recusar a proposta?',
        rejectReason: 'Motivo da recusa',
        cancelTitle: 'Cancelar a proposta?',
        cancelReason: 'Motivo do cancelamento',
        reviseTitle: 'Criar uma nova versão?',
        reviseText: 'A proposta volta para rascunho na versão {version}, para você editar e enviar de novo.',
        deleteTitle: 'Excluir a proposta?',
        deleteText: 'Esta ação não pode ser desfeita.',
      },
      approved: 'Proposta aprovada',
      approvedResult: '{entries} lançamento(s) criado(s){monthly}{project}.',
      approvedMonthly: ', mensalidade no financeiro',
      approvedCommission: ', {n} a pagar de comissão de indicação | , {n} a pagar de comissão de indicação',
      approvedProject: ', projeto em andamento',
      approvedNewProject: ', projeto criado e em andamento',
      approvedNewProjectTasks: ', projeto criado com 1 tarefa | , projeto criado com {n} tarefas',
      sent: 'Proposta marcada como enviada',
      rejected: 'Proposta recusada',
      cancelled: 'Proposta cancelada',
      revised: 'Nova versão criada',
      pdfReady: 'PDF gerado',
    },
  },
}
